// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7d288ec5","455":"fee067fd","977":"5aeffed2"}[chunkId] + ".chunk.js";
};